import { render, staticRenderFns } from "./WhatIsVioOnVideoModal.vue?vue&type=template&id=401efb98&"
import script from "./WhatIsVioOnVideoModal.vue?vue&type=script&lang=js&"
export * from "./WhatIsVioOnVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports